import React, { forwardRef } from 'react';

type DivProps = Omit<JSX.IntrinsicElements['div'], 'title'>;
interface ThreadOptionsStructureProps extends DivProps {
  icon: JSX.Element;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

/**
 *
 * @param icon
 * @param title
 * @param subtitle
 * @param props
 * @constructor
 */
export const ThreadOptionsStructure = forwardRef<HTMLDivElement, ThreadOptionsStructureProps>(
  (props, ref) => {
    const { icon, title, subtitle, ...others } = props;
    return (
      <div
        ref={ref}
        className="flex items-center space-x-3 m px-4 h-10 cursor-pointer
      hover:text-primary-base transition-colors duration-200"
        {...others}
      >
        <div className="w-4 h-4 flex items-center justify-center">{icon}</div>
        <div className="flex-1">
          <div className="prose-sub whitespace-nowrap">{title}</div>
          {subtitle && <div className="prose-caption text-gray-medium">{subtitle}</div>}
        </div>
      </div>
    );
  },
);
